var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.3963C2 8.94859 2.44772 9.3963 3 9.3963H4.64494C5.07521 10.842 6.41449 11.8963 8 11.8963C9.58551 11.8963 10.9248 10.842 11.3551 9.3963H21C21.5523 9.3963 22 8.94859 22 8.3963C22 7.84402 21.5523 7.3963 21 7.3963H11.3523C10.9203 5.98349 9.5881 5 8 5C6.4119 5 5.07975 5.98349 4.64765 7.3963H3C2.44772 7.3963 2 7.84402 2 8.3963ZM2 15.3963C2 15.9486 2.44772 16.3963 3 16.3963H12.6449C13.0752 17.842 14.4145 18.8963 16 18.8963C17.5855 18.8963 18.9248 17.842 19.3551 16.3963H21C21.5523 16.3963 22 15.9486 22 15.3963C22 14.844 21.5523 14.3963 21 14.3963H19.3551C18.9248 12.9506 17.5855 11.8963 16 11.8963C14.4145 11.8963 13.0752 12.9506 12.6449 14.3963H3C2.44772 14.3963 2 14.844 2 15.3963ZM16 16.8963C16.8284 16.8963 17.5 16.2247 17.5 15.3963C17.5 14.5679 16.8284 13.8963 16 13.8963C15.1716 13.8963 14.5 14.5679 14.5 15.3963C14.5 16.2247 15.1716 16.8963 16 16.8963ZM9.5 8.3963C9.5 9.22473 8.82843 9.8963 8 9.8963C7.17157 9.8963 6.5 9.22473 6.5 8.3963C6.5 7.60128 7.13783 7 8 7C8.86217 7 9.5 7.60128 9.5 8.3963Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.f9158d2fd3cd6f9867a02ddf44414a31.svg";
export { ForwardRef as ReactComponent };